import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "verify-form" }
const _hoisted_2 = { class: "mb-6 absolute top-8 inset-x-8" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4 text-xs"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_FormError = _resolveComponent("FormError")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_InputCodeField = _resolveComponent("InputCodeField")!
  const _component_AvailableMethodSelector = _resolveComponent("AvailableMethodSelector")!
  const _component_snap_link = _resolveComponent("snap-link")!
  const _component_snap_button = _resolveComponent("snap-button")!
  const _directive_autofocus = _resolveDirective("autofocus")!
  const _directive_keyboard_submit = _resolveDirective("keyboard-submit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showSendAlert)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            type: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" We’ve sent a verification code to " + _toDisplayString(_ctx.composeTransportRecipients), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showReSendAlert)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 1,
            type: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" We’ve sent a new verification code to " + _toDisplayString(_ctx.composeTransportRecipients), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_FormError, { error: _ctx.error }, null, 8, ["error"])
    ]),
    _withDirectives(_createVNode(_component_PageTitle, { class: "mb-4" }, {
      default: _withCtx(() => [
        _createTextVNode(" Verify Your Account ")
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.participants]
    ]),
    (_ctx.composeTransportLabels)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " To complete your account set up we’ve sent a verification code to your " + _toDisplayString(_ctx.composeTransportLabels) + ". ", 1))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.verifyCode()), ["prevent"]))
    }, [
      _withDirectives(_createVNode(_component_InputCodeField, {
        class: "mb-2",
        label: "Enter verification Code",
        modelValue: _ctx.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
        validation: _ctx.v$.code,
        "help-text": "Enter your 6-digit verification code.",
        "data-testid": "auth_code"
      }, null, 8, ["modelValue", "validation"]), [
        [_directive_autofocus]
      ]),
      (_ctx.featureOff?.('USER-527-allow-to-skip-verification'))
        ? (_openBlock(), _createBlock(_component_AvailableMethodSelector, {
            key: 0,
            class: "mb-2",
            available: _ctx.confirmationAvailableTransports,
            onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resendCode($event)))
          }, null, 8, ["available"]))
        : _createCommentVNode("", true),
      (_ctx.featureOn?.('USER-527-allow-to-skip-verification'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_snap_link, {
              class: "block",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resendCode()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Send New Code ")
              ]),
              _: 1
            }),
            (_ctx.canSkipVerification)
              ? (_openBlock(), _createBlock(_component_snap_link, {
                  key: 0,
                  class: "block",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.skipVerification())),
                  "data-testid": "verification_skip"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Skip Verification At This Time ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_snap_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.declineVerification())),
          "button-type": "button",
          shape: "circular",
          size: "lg",
          variant: "tertiary",
          class: "inline-block mr-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel ")
          ]),
          _: 1
        }),
        _createVNode(_component_snap_button, {
          "button-type": "submit",
          disabled: _ctx.state$.is('SUBMITTING'),
          shape: "circular",
          size: "lg",
          variant: "primary",
          class: "inline-block",
          "data-testid": "confirm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Confirm ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 32)), [
      [_directive_keyboard_submit]
    ])
  ]))
}